import React from "react";
import { withNavBars } from "../../HOCs";
import DeliveryMilestoneTemplate from "./deliveryMilestoneTemplate";

class DeliveryMilestoneTemplateParent extends React.Component {
    render() {
        return <DeliveryMilestoneTemplate  {...this.props} />;
    }
}
const props = {
    boxShadow: false
}
export default withNavBars(DeliveryMilestoneTemplateParent, props);
